"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M23 2H1v16h9l-2 3v1h8v-1l-2-3h9zm-2 12H3V4h18z"
}), 'DesktopMacSharp');